import {lazy} from 'react';

const loadModule = () => import('./routes/ModuleRoutes');
export const SubscriptionsModule = lazy(loadModule);

export default SubscriptionsModule;
